import lf from 'localforage';

export default {
    install(Vue) {
        Vue.prototype.$cache = lf.createInstance({ name: 'cache' });
    }
};
